import { API_ROUTE_V2_PREFIX, IOrderDetailsRequestParams } from "@tm/api-utils";
import { LOB } from "@tm/isomorphic-utils";
import { getLobOnServerSide } from "@tm/server-utils";
import { API_HTTP } from "../apiInstance";
import { setURLQueryParams } from "../setURLQueryParams";

/**
 * TEMP API - Temporary endpoint for polling policy status
 * TODO: Replace with actual API endpoint when available
 */
export const getPolicyStatus = async (
  data: IOrderDetailsRequestParams
): Promise<{
  responseStatus: string;
  message: string;
  data: {
    policyStatus:
      | "GENERATING_POLICY"
      | "GENERATING_POLICY_SUCCESS"
      | "GENERATING_POLICY_FAILED"
      | "UPDATING_POLICY"
      | "UPDATING_POLICY_SUCCESS"
      | "UPDATING_POLICY_FAILED";
  };
}> => {
  try {
    const { partner, bookingId, headers, cmp, query, dvid } = data || {};
    const params = {
      lob: getLobOnServerSide(partner) || LOB.STANDALONE,
      bookingId,
      ...query,
    };

    const urlParams = setURLQueryParams(params);

    // TEMP: Using a temporary endpoint - replace with actual endpoint
    const response = await API_HTTP.get(
      `${API_ROUTE_V2_PREFIX}/${partner}/insurance/cb/policyStatus${
        urlParams ? `?${urlParams}` : ""
      }`,
      {
        headers: { ...headers, cmp, dvid },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error fetching policy status", { error });
    throw error;
  }
};
